import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { MailCheck } from "lucide-react";

const inputCls =
  "w-full bg-[#0a0a0a] border border-[#262626] focus:border-white outline-none px-4 py-3 rounded-sm text-white transition-colors";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4" data-testid="forgot-password-page">
      <div className="w-full max-w-sm">
        <h1 className="font-display text-4xl uppercase tracking-tight text-white mb-1">EGNCY</h1>
        <p className="text-sm text-[#a3a3a3] mb-6">Reset your password.</p>
        {sent ? (
          <div data-testid="forgot-sent" className="bg-[#121212] border border-[#262626] rounded-sm p-6 space-y-3">
            <MailCheck className="w-8 h-8 text-green-400" />
            <p className="text-white font-semibold">Check your email</p>
            <p className="text-sm text-[#a3a3a3]">
              If an account exists for <span className="text-white">{email}</span>, we've sent a reset link.
              It's valid for 1 hour.
            </p>
            <Link to="/login" data-testid="forgot-back-login" className="inline-block text-sm text-white hover:underline">
              Back to log in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-[#121212] border border-[#262626] rounded-sm p-6 space-y-4">
            {error && (
              <div data-testid="forgot-error" className="text-sm text-red-400 border border-red-500/40 bg-red-500/10 p-3 rounded-sm">{error}</div>
            )}
            <p className="text-sm text-[#a3a3a3]">Enter your account email and we'll send you a reset link.</p>
            <input
              data-testid="forgot-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className={inputCls}
            />
            <button
              data-testid="forgot-submit"
              disabled={loading}
              className="w-full bg-white text-black font-semibold py-3 rounded-sm hover:bg-gray-200 disabled:opacity-60 transition-colors"
            >
              {loading ? "Sending…" : "Send reset link"}
            </button>
            <div className="text-sm text-[#a3a3a3] text-center">
              <Link to="/login" className="text-white hover:underline">Back to log in</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
